import React from "react";

const OurEmployees = () => {
  return (
    <section className='my-10'>
      <h2 className="text-4xl text-center font-bold mb-5">
        Our <span className="text-primary">Employees</span>
      </h2>

        <div className='flex  flex-wrap justify-center'>
            <img src="https://i.ibb.co/DMq5BZH/images8.jpg" alt='' />
            <img src="https://i.ibb.co/GC4W2dG/worder2.jpg" alt='' />
            <img src="https://i.ibb.co/bbBPgh0/worder5.jpg" alt='' />
            <img src="https://i.ibb.co/d2x5kZD/worder6.jpg" alt='' />
            <img src="https://i.ibb.co/2ZxBksR/worder7.jpg" alt='' />
            <img src="https://i.ibb.co/Fz4QsQC/worker1.jpg" alt='' />
            <img src="https://i.ibb.co/3c21gLS/worker3.jpg" alt='' />
            <img src="https://i.ibb.co/VWtfssp/worker4.jpg" alt='' />
        </div>
    </section>
  );
};

export default OurEmployees;
